import { render } from "./AboutView.vue?vue&type=template&id=4df6daf0&scoped=true"
import script from "./AboutView.vue?vue&type=script&lang=js"
export * from "./AboutView.vue?vue&type=script&lang=js"

import "./AboutView.vue?vue&type=style&index=0&id=4df6daf0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df6daf0"]])

export default __exports__